export default "__VITE_ASSET__CMa3kizF__"